import script from "./AdminHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHome.vue?vue&type=script&setup=true&lang=js"

import "./AdminHome.vue?vue&type=style&index=0&id=cd205184&lang=css"

const __exports__ = script;

export default __exports__